import React, { Suspense } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";

const useAccordionStyles = makeStyles({
  accordionSummary: {
    flexDirection: "row-reverse",
    backgroundColor: "#47856d",
    color: "white",
  },
  accordionDetails: {
    height: "500px",
    overflowY: "auto",
  },
});

const LazyAccordion = ({
  label,
  count,
  groupKey,
  isExpanded,
  onToggle,
  LazyComponent,
}) => {
  const classes = useAccordionStyles();

  return (
    <Accordion expanded={isExpanded} onChange={() => onToggle(groupKey)}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography>
          {label} ({count})
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <Suspense fallback={<div>Loading table...</div>}>
          {isExpanded && <LazyComponent group={groupKey} />}
        </Suspense>
      </AccordionDetails>
    </Accordion>
  );
};

export default LazyAccordion;
